/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, PrivateRoute } from '@insticator/insticator-ui'; // iui-material
// pages
// utils
// thunks
// styles
import injectSheet from 'react-jss';
import styles from './articlesentimentv2_styles';
import ArticleSentimentV2ConfigPage from './articlesentimentv2config/articlesentimentv2config';
import ArticleSentimentV2AnalyticsPage from './articlesentimentv2analytics/articlesentimentv2analytics';



/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT V2 DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
  const { accountProductsReceived, accountProducts, accountProductRequestStatus } = useSelector(state => state.account);
  const hasTrendingNowV2 = accountProducts.includes('ARTICLE_SENTIMENT_V2')

  const permittedToConfig = hasTrendingNowV2 && accountProductsReceived
  const _getPermittedPath = useCallback(() => {
    if (accountProductRequestStatus === 'failed' || !accountProductsReceived) {
        return `/error/403`;
    }
    if (hasTrendingNowV2) {
        return '/dashboard/trendingnow/configuration'
    }
  }, [hasTrendingNowV2])

    return (
    <Division name={`articlesentimentv2`} klass={props.classes.articlesentimentv2}>
        <Switch>
            {/*Routes to subdivisions*/}
            <Route exact path='/dashboard/articlesentiment' render={() => <Redirect to={'dashboard/articlesentiment/configuration'} />} />
            <PrivateRoute permitted={permittedToConfig} redirectTo={_getPermittedPath()} path={'/dashboard/articlesentiment/configuration'} component={ArticleSentimentV2ConfigPage} />
            <PrivateRoute permitted={permittedToConfig} redirectTo={_getPermittedPath()} path={'/dashboard/articlesentiment/analytics'} component={ArticleSentimentV2AnalyticsPage} />
            <Redirect to='/error/404'/>
        </Switch>
    </Division>
    )
})